import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useCart } from '../commerce/CartContext';
import { formatCurrency, products as fallbackProducts } from '../data';
import { getProducts } from '../services/catalogueService';

function ProductCard({ product, index }) {
  const { addItem } = useCart();
  const requiresOption = product.variants?.length > 0;
  const unavailable = product.id ? !product.inStock : false;

  return (
    <motion.article
      className="product-card"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: (index % 4) * 0.08 }}
    >
      <Link className="product-image" to={`/product/${product.slug}`}>
        <img
          src={product.image}
          alt={product.imageAlt || `${product.name} saree`}
          loading="lazy"
        />
      </Link>
      <div className="product-info">
        <h3>{product.name}</h3>
        <p>{formatCurrency(product.price)}</p>
        {unavailable ? (
          <button className="outline-button" disabled>Out of stock</button>
        ) : requiresOption ? (
          <Link className="outline-button" to={`/product/${product.slug}`}>
            View product
          </Link>
        ) : (
          <button className="outline-button" onClick={() => addItem(product)}>
            Add to cart
          </button>
        )}
      </div>
    </motion.article>
  );
}

function Collection() {
  const [catalogue, setCatalogue] = useState([]);
  const [state, setState] = useState('loading');

  useEffect(() => {
    let active = true;

    getProducts({ limit: 8 })
      .then(({ products }) => {
        if (active) {
          setCatalogue(products);
          setState('ready');
        }
      })
      .catch(() => {
        if (active) {
          setCatalogue(fallbackProducts);
          setState('fallback');
        }
      });

    return () => {
      active = false;
    };
  }, []);

  return (
    <section className="collection section" id="collection">
      <header className="section-heading">
        <span className="eyebrow">Featured Collection</span>
        <h2>The ZEVI Collection</h2>
        <p>Curated elegance for every occasion.</p>
      </header>

      {state === 'loading' && (
        <p className="commerce-message" role="status">
          Curating the collection…
        </p>
      )}

      {state === 'fallback' && (
        <p className="commerce-notice" role="status">
          Live availability is temporarily unavailable. Stock will be verified
          before checkout.
        </p>
      )}

      {state !== 'loading' && catalogue.length === 0 ? (
        <p className="commerce-message">No products are currently available.</p>
      ) : (
        <div className="product-grid">
          {catalogue.map((product, index) => (
            <ProductCard
              key={product.id || product.slug}
              product={product}
              index={index}
            />
          ))}
        </div>
      )}

      {state !== 'loading' && catalogue.length > 0 && (
        <div className="collection-view-all">
          <Link className="gold-button" to="/shop">
            View all sarees
          </Link>
        </div>
      )}
    </section>
  );
}

export default Collection;